import React from "react";
import styles from "./Item.module.scss";
import { Typography, Card } from "@material-ui/core";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import { useParams, useHistory } from "react-router";
import { IBillingResult } from "nodeDetails/types";
import { UnixToDateConverter } from "common/DateConverter";
import {
  calculateTotal,
  getDisplayBillingPeriod,
} from "nodeDetails/functions/billingResultFunctions";
import { useDomainNumberFormatter } from "common/useNumberFormatter";
import { longMonthNames } from "nodeDetails/functions/dateFunctions";

interface Props {
  billingResult: IBillingResult;
}

const Item = ({ billingResult }: Props) => {
  const history = useHistory();
  const { formatCurrency } = useDomainNumberFormatter();
  const { domain, id } = useParams<{ domain: string; id: string }>();

  const totalPrice = calculateTotal(billingResult);

  const openBillingResult = () => {
    history.push(`/${domain}/${id}/billing-results/${billingResult.ID}`);
  };

  return (
    <Card className={styles.billingResult} onClick={openBillingResult}>
      <div className={styles.content}>
        <div className={styles.date}>
          <Typography variant="body2">
            {longMonthNames[UnixToDateConverter(billingResult.Start).month()]}
          </Typography>
          <Typography color="textSecondary" variant="subtitle1">
            {getDisplayBillingPeriod(billingResult.Start, billingResult.End)}
          </Typography>
        </div>
        <Typography variant="body2">
          {formatCurrency(
            totalPrice.total + totalPrice.vat + totalPrice.rounding
          )}
        </Typography>
      </div>
      <ArrowForwardIosIcon fontSize="small" />
    </Card>
  );
};

export default Item;
